/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import React from 'react'
import styles from './Avatar.module.scss'
import {PlayerColor, TradeResponseStatus} from '@colonist/game-states'
import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {getLobbyImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {ColonistMembershipProduct} from '../../../../../code/shared/store/ColonistMembershipProduct'
import {navigateToPage} from '../../../../../code/client/shared/scripts/ui_utils/ClientUtils'
import IconAddFriend from '@static/images/icon_add_friend.svg'
import EmbargoOverlay from '@static/images/avatar_embargo_overlay.svg'
import PlayerStatusAccept from '@static/images/player_status_accept.svg'
import PlayerStatusReject from '@static/images/player_status_reject.svg'
import PlayerStatusPending from '@static/images/player_status_pending.svg'

const getTradeResponseStatusIcon = (tradeResponseStatus: TradeResponseStatus) => {
    switch(tradeResponseStatus) {
        case TradeResponseStatus.Accepted: return PlayerStatusAccept
        case TradeResponseStatus.Rejected: return PlayerStatusReject
        case TradeResponseStatus.PendingResponse: return PlayerStatusPending
        case TradeResponseStatus.Embargoed: return undefined
    }
}
export interface AvatarProps {
    image?: LobbyImage | undefined
    hideBackground?: boolean
    color?: PlayerColor | undefined
    className?: string
    showPlusIcon?: boolean
    membership?: ColonistMembershipType | undefined
    onClick?: VoidFunction
    profilePictureUrl?: string | undefined
    isEmbargoed?: boolean
    tradeResponseStatus?: TradeResponseStatus | undefined
}

export const Avatar = ({
    className = '',
    image,
    color,
    hideBackground,
    showPlusIcon,
    membership,
    onClick,
    profilePictureUrl,
    isEmbargoed,
    tradeResponseStatus,
}: AvatarProps) => {
    const hasMembership = membership != null
    const hasLobbyImage = image != null && !profilePictureUrl
    const hasProfilePicture = profilePictureUrl != null
    const hasColor = color != null
    const backgroundColor = hasColor ? PlayerColor[color]?.toLowerCase() : null
    const isBotImage = image === LobbyImage.Bot
    const tradeResponseStatusIcon = (tradeResponseStatus != null) ? getTradeResponseStatusIcon(tradeResponseStatus) : null

    return (<div
        className={clsx(styles.container,
            backgroundColor && styles[backgroundColor],
            {
                [styles.hideBackground]: hideBackground || !hasColor,
                [styles.hasBackground]: hasColor && !hideBackground,
            }, className)}
        onClick={onClick}
    >
        {showPlusIcon && (
            <div className={clsx(styles.icon, styles.plus)}>
                <img className={styles.image} draggable={false} src={IconAddFriend} />
            </div>
        )}

        {hasMembership && (
            <div
                className={clsx(styles.icon, styles.membership)}
                onClick={(e) => {
                    e.stopPropagation()
                    navigateToPage('/store#membership', true)
                }}
            >
                <img
                    className={styles.image}
                    draggable={false}
                    src={getLobbyImagePath(ColonistMembershipProduct.getMembershipProduct(membership).lobbyImage)} />
            </div>
        )}
        {isEmbargoed && (
            <img
                draggable={false}
                className={styles.embargoOverlay}
                src={EmbargoOverlay}
            />
        )}
        {tradeResponseStatusIcon && (
            <img
                draggable={false}
                className={styles.tradeResponseStatus}
                src={tradeResponseStatusIcon}
            />
        )}
        {hasLobbyImage && (
            <img
                draggable={false}
                className={clsx(styles.avatarImage, {
                    [styles.isBot]: isBotImage,
                    [styles.embargoed]: isEmbargoed,
                })}
                src={getLobbyImagePath(image)}
            />
        )}
        {hasProfilePicture && (
            <img
                draggable={false}
                className={clsx(styles.avatarImage, styles.profilePicture, {
                    [styles.embargoed]: isEmbargoed,
                })}
                src={profilePictureUrl}
            />
        )}
    </div>)
}
